<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
  <a
      v-if="isExternal"
      :href=uri
      :target=targetWindow
      rel="noopener"
      class="external-link"
  >
    <slot/>
  </a>
  <router-link
      v-else
      v-bind="$props"
      class="internal-link"
   >
    <slot/>
  </router-link>

</template>

<script>
import {RouterLink} from 'vue-router';

export default {
  name: "HZLink",
  data() {
    return {
      uri: null,
      targetWindow: "_blank"
    }
  },
  props: {
    ...RouterLink.props,
  },

  methods: {
    processTarget() {
      let externalTarget = false;
      if (typeof this.to === 'string' && (this.to.startsWith('http') || this.to.startsWith('mailto'))) {
        externalTarget = true;
        this.uri = this.to;
      }

      if (this.to && this.to.type) {
        switch (this.to.type) {
          case 'default':

            break;
          case 'phone':
          case 'email':
          case 'linkedin':
          case 'instagram':
          case 'facebook':
            externalTarget = true;
            this.uri = this.to.name;
            this.target = this.to.target;
            break;
          default:
            break;
        }
      }

      return externalTarget

    }
  },

  computed: {
    isExternal() {
      return this.processTarget();
    },

  }

}
</script>

<style scoped>

</style>